<template>
  <div>
    <!-- Modificatore della variabile act-for per richiedere dati di altre aziende -->
    <!-- associate al referente aziendale -->
    <SwitcherAziende/>

    <PageTagline :is_ref_azi_area="true" :elements="tagline_elem"/>

    <!-- Overlay di caricamento/invio messaggio -->
    <CustomOverlay :show="show_overlay" :text="'Invio richiesta...'">

      <!-- Card di contenimento della pagina -->
      <b-card title="Loyalty & Incentive" class="mr-1 ml-1">
        <p>
          <i><u>
          Compilando e inviando la presente richiesta d'ordine, dichiaro di aver preso visione del funzionamento del servizio
          Loyalty & Incentive e di accettare il pagamento della commissione prevista per il servizio offerto da Welfarebit,
          come dettagliato nello schema sottostante.
          La richiesta d'ordine è replicabile dall'azienda ad ogni necessità e non genera vincoli contrattuali.
          </u></i>
        </p>
        <!-- Card di contenimento della parte con il form di invio mail per il caricamento del credito -->
        <b-card no-body class='mb-2 p-2'>
          <b-row>
            <b-col>
              <h5>Ricarica account:</h5>
              <p>Inserisci la somma in euro da caricare sul tuo account e clicca il pulsante "Invia Richiesta" per comunicarlo al nostro backoffice:</p>
              <b-form @submit.prevent="onSubmit">
                <b-form-group
                  id="group-val-ricarica"
                  label="Importo da ricaricare:"
                  label-for="val-ricarica"
                  description="Immettere un importo in euro valido, utilizzando il punto come separatore decimale."
                >
                  <b-input-group prepend="€">
                    <b-form-input
                      id="val-ricarica"
                      v-model="importo_ricarica"
                      @keyup="check_euro_importo"
                      required
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
                <p>Servizi (3%): <b>{{totale_servizi}} €</b></p>
                <p>IVA (22%): <b>{{totale_iva}} €</b></p>
                <p class="tot-fattura"><u>Totale Fattura: <b>{{totale_fattura}} €</b></u></p>
                <b-button type="submit" variant="primary">Invia Richiesta</b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-card>
        <!-- Parte di accesso al portale Toduba -->
        <b-card no-body class='mt-4 p-2'>
          <b-row>
            <b-col>
              <h5>Accedi al portale:</h5>
              <p>Una volta <b>avuta conferma circa il caricamento del credito desiderato</b>, clicca qui sotto per accedere al portale <b>Loyalty & Incentive</b>:</p>
              <b-button block size="lg" variant="primary" href="https://clienti.toduba.it" target="_blank"><b>Accedi a Loyalty & Incentive</b></b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-card>
    </CustomOverlay>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import SwitcherAziende from '@/components/refaziendale/SwitcherAziende.vue'
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'IncentiveToduba',
  data() {
    return {
      // Variabili di base della pagina
      tagline_elem : [ { text : "Loyalty & Incentive", link: "office-incentive-toduba" } ],

      // Overlay di caricamento
      show_overlay : false,

      // Importo da ricaricare
      importo_ricarica : null
    };
  },
  computed : {
    // Calcolo dei servizi ( 3% su importo ricarica )
    totale_servizi : function () {
      let servizi = "0.00";
      let importo_ricarica = parseFloat(this.importo_ricarica);
      if ( !isNaN(this.importo_ricarica) && importo_ricarica > 0 ){
        servizi = (importo_ricarica * 0.03).toFixed(2);
      }
      // L'uso di toFixed(2) per avere solo 2 decimali, converte in stringa il numero.
      return servizi
    },
    // Calcolo dell'IVA ( 22% sul 3% dei servizi )
    totale_iva : function () {
      // L'uso di toFixed(2) per avere solo 2 decimali, converte in stringa il numero.
      let tot_iva = (parseFloat(this.totale_servizi) * 0.22).toFixed(2);
      return tot_iva;
    },
    // Calcolo del totale della fattura ( ricarica più costi di servizio e IVA )
    totale_fattura : function () {
      let totale_fattura = "0.00";
      let importo_ricarica = parseFloat(this.importo_ricarica);
      if ( !isNaN(this.importo_ricarica) && importo_ricarica > 0 ){
        totale_fattura = ( importo_ricarica + parseFloat(this.totale_servizi) + parseFloat(this.totale_iva)).toFixed(2);
      }
      return totale_fattura;
    }
  },
  methods : {
    /**
     * Esecuzione della ricarica
     */
    onSubmit : function () {

      const confirm_message = 'Confermi la disposizione di ricarica per un importo pari a ' + this.importo_ricarica + ' euro?';

      this.$bvModal.msgBoxConfirm( confirm_message, {
        title: 'Conferma operazione',
        noCloseOnEsc: true,
        noCloseOnBackdrop: true,
        okTitle: 'Conferma',
        cancelTitle: 'Annulla',
        hideHeaderClose: true,
        centered: true
      })
      .then( ( value ) => {
        if ( value ){
          this.invia_messaggio();
        }
      })
      .catch( ( err ) => {
        console.error(err)
      })
    },
    /**
     * Invio del messaggio al backend per la ricarica del credito
     */
    invia_messaggio : function () {

      this.show_overlay = true;

      const data_to_send = {
        importo_ricarica : this.importo_ricarica
      };

      axios.post( apiUrl.welfareapi.ricarica_incentive_toduba , data_to_send )
      .then( (response) => {

        this.show_overlay = false;

        // Se tutto ok il backend torna con un 204_NO_CONTENT
        this.$bvModal.msgBoxOk('Richiesta inviata correttamente.', {
          title: 'Richiesta inviata',
          centered: true,
          noCloseOnEsc: true,
          noCloseOnBackdrop: true
        })
        .then(value => {
          // Resettiamo il valore dell'importo dopo aver dato l'ok.
          this.importo_ricarica = null;
        });

      })
      .catch( (error) => {
          this.show_overlay = false;
          generalLib.backend_error_message_box( this, error.response.data );
      });
    },
    /**
     * Controllo dell'importo in euro, se il check fallisce, viene eliminato l'ultimo carattere
     * scritto dall'utente.
     */
    check_euro_importo : function () {
      if ( !generalLib.euro_is_valid( this.importo_ricarica ) ){
        this.importo_ricarica = this.importo_ricarica.slice(0,this.importo_ricarica.length - 1);
      }
    }
  },
  components: {
    PageTagline,
    SwitcherAziende,
    CustomOverlay
  }
}
</script>

<style scoped>
/* Se siamo sul desktop, la larghezza del campo di input per la cifra della ricarica
   è del 15% per non occupare tutto lo spazio dispionibile, lo espadiamo invece al 100%
   sui dispositivi più piccoli. */
#group-val-ricarica .input-group {
  width: 15%;
}

@media (max-width: 576px) {
  #group-val-ricarica .input-group {
    width: 100%;
  }
}

.tot-fattura {
  font-size: 1.4em;
}
</style>
